import { Header2, IconChevronDownSmall16, IconChevronUpSmall16, InlineText1, InlineText2 } from '@cian/ui-kit';

import { PureComponent } from 'react';
import LinesEllipsis, { IOnReflow } from 'react-lines-ellipsis';

import { IDescriptionProps, IDescriptionState } from './types';

import * as styles from './styles.css';

export const DEFAULT_LINE_COUNT = 8;
export const DEFAULT_MORE_NOT_EXPANDED_TEXT = 'Читать больше';
export const DEFAULT_MORE_EXPANDED_TEXT = 'Скрыть';

/* istanbul ignore next */
export class Description extends PureComponent<IDescriptionProps, IDescriptionState> {
  public constructor(props: IDescriptionProps) {
    super(props);

    this.state = {
      expanded: false,
      clamped: false,
    };
  }

  public static defaultProps: Partial<IDescriptionProps> = {
    moreNotExpandedText: DEFAULT_MORE_NOT_EXPANDED_TEXT,
    moreExpandedText: DEFAULT_MORE_EXPANDED_TEXT,
    showLines: DEFAULT_LINE_COUNT,
  };

  private toggleLines = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();

    this.setState(({ expanded }) => ({ expanded: !expanded }));
  };

  private handleReflow = (reflow: IOnReflow) => {
    const { clamped } = reflow;

    this.setState({
      clamped,
    });
  };

  public render() {
    const { description, showLines, moreNotExpandedText, moreExpandedText } = this.props;
    const { expanded, clamped } = this.state;

    if (!description) {
      return null;
    }

    const descriptionTextView = expanded ? (
      <p className={styles['paragraph']}>{description}</p>
    ) : (
      <LinesEllipsis
        trimRight
        basedOn="words"
        className={styles['paragraph']}
        component="p"
        data-testid="lines-ellipsis-test-id"
        ellipsis=""
        maxLine={showLines}
        text={description}
        onReflow={this.handleReflow}
      />
    );

    return (
      <div className={styles['description']} data-nav-tab="description/О коворкинге" id="description">
        <div>
          <Header2 as="span" color="black_100" fontWeight="bold">
            О коворкинге
          </Header2>
        </div>
        <div className={styles['text']}>
          <InlineText1 as="span" color="black_100" fontWeight="normal">
            {descriptionTextView}
          </InlineText1>
          <div className={styles['toggle']} data-testid="toggle-lines-test-id" onClick={this.toggleLines}>
            <span>
              <InlineText2 as="span" color="primary_100" fontWeight="normal">
                {clamped && !expanded && moreNotExpandedText}
                {expanded && moreExpandedText}
              </InlineText2>
              {clamped && !expanded && (
                <span className={styles['icon']}>
                  <IconChevronDownSmall16 color="primary_100" display="inline-block" />
                </span>
              )}
              {expanded && <IconChevronUpSmall16 color="primary_100" display="inline-block" />}
            </span>
          </div>
        </div>
      </div>
    );
  }
}
